import type { PublicContentBlock } from './types'

/**
 * Les textes à place fixe du site : légende du décor, titre du concours,
 * introductions des pages « Infos » et « L'équipe ».
 *
 * Ils se réécrivent dans Admin → Contenus (blocs `site.*`, créés à chaque
 * déploiement s'ils manquent, jamais réécrits). Ils ne sont jamais affichés
 * comme section éditoriale libre : chacun a sa place.
 *
 * Le serveur renvoie un bloc `site.*` même masqué — vide. Absent (une édition
 * créée depuis le dernier déploiement), l'écran retombe sur son texte de
 * secours ; présent mais vide, il n'affiche rien : c'est ce qu'on a voulu.
 */
export const SITE_TEXT_PREFIX = 'site.'

/**
 * Les blocs qui ont leur propre page : textes légaux (/cgv, /confidentialite…)
 * et introductions des tables (/menu, personnalisation d'une table).
 */
const OWN_PAGE_PREFIXES = ['legal.', 'tables.']

/** Un bloc qui n'est pas une section éditoriale libre. */
export function hasFixedPlace(key: string, promoted: ReadonlySet<string> = new Set()): boolean {
  return (
    key.startsWith(SITE_TEXT_PREFIX) ||
    OWN_PAGE_PREFIXES.some((prefix) => key.startsWith(prefix)) ||
    promoted.has(key)
  )
}

export function siteText(
  blocks: PublicContentBlock[] | undefined,
  key: string,
): PublicContentBlock | undefined {
  return blocks?.find((block) => block.key === key)
}
